import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { settings } from '../conf'

export const STORAGE_KEY = `forwalk-lastRoute-${settings.BASE_NAME}`;
const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isHome = window.location.pathname == settings.BASE_NAME

const PersistedRouteManager = ({ settings }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Controllare se l'app è in modalità standalone
    if (isStandalone && isHome) {
      const lastRoute = localStorage.getItem(STORAGE_KEY);
      if (lastRoute) {
        history.replace(lastRoute);
      }
    }
  }, [history]);

  useEffect(() => {
    // Salvare l'ultimo percorso nel localStorage
    localStorage.setItem(STORAGE_KEY, location.pathname);
  }, [location.pathname]);

  return null; // Questo componente non ha output visivo
};

export default PersistedRouteManager;
